import React from 'react';
import { SortableContainer, SortableElement, sortableHandle } from 'react-sortable-hoc';
import { FiMenu, FiEdit3, FiCheck } from "react-icons/fi";
import i18next from "i18next";
import {
	getScopeDisplayLabel,
	normalizeScopeForApi,
	resolvePlanViewScopes,
} from "./planViewColumns";

const DragHandle = sortableHandle(() => <span className="column-move"><FiMenu className="column-move-icon" /></span>);

const ColumnItem = SortableElement(({ item, index, handleColumn, scopes }) => {
	let tipo = "";
	let id = "";

	if (item.transaction_rule_id) {
		tipo = i18next.t('planViews.typeRule');
		id = `col_transaction_rule_${item.transaction_rule_id}`;
	}
	else if (item.account_id) {
		tipo = i18next.t('planViews.typeAccount');
		id = `col_account_${item.account_id}`;
	}

	const checked = item.checked;
	const scopeValue = normalizeScopeForApi(item.scope, scopes);

	return (
		<li key={index} aria-label={item.name} title={item.name} className="column-item">
			<div className="column-left checkbox">
				<input
					type="checkbox"
					id={id}
					onChange={(e) => handleColumn(item, e, { action: 'select' })}
					checked={checked}
				/>
				<label
					htmlFor={id}
					className="btn-check-label"
				>
					{item.edit ?
						<input
							type="text"
							id={`label_${id}`}
							className="form-control column-label-edit"
							onChange={(e) => handleColumn(item, e, { action: 'label-edit' })}
							value={item.label}
						/>
						:
						<span className="column-item-label">{item.label}</span>
					}

					<span className="column-item-tipo">{tipo}</span>
				</label>

				{item.edit ?
					<button
						type="button"
						className="column-label-btn"
						onClick={(e) => handleColumn(item, e, { action: 'edit-mode', value: false })}
					>
						<FiCheck className="column-label-icon" aria-label={i18next.t('common.accept')} />
					</button>
					:
					<button
						type="button"
						className="column-label-btn"
						onClick={(e) => handleColumn(item, e, { action: 'edit-mode', value: true })}
					>
						<FiEdit3 className="column-label-icon" aria-label={i18next.t('planViews.editLabel')} />
					</button>
				}
			</div>
			<div className="column-right">
				<select
					id={`scope_${id}`}
					className="form-control column-item-scope"
					value={scopeValue}
					onChange={(e) => handleColumn(item, e, { action: 'scope' })}
				>
					{scopes.map((scope) => (
						<option key={scope} value={scope}>
							{getScopeDisplayLabel(scope)}
						</option>
					))}
				</select>

				<DragHandle />
			</div>
		</li>
	)
});

const ColumnList = SortableContainer(({ items, handleColumn, scopes }) => {
	const resolvedScopes = resolvePlanViewScopes(scopes);

	return (
		<ul className="list-columns">
			{items.map((item, index) => (
				<ColumnItem
					key={`item-${index}`}
					handleColumn={handleColumn}
					sortIndex={index}
					index={index}
					item={item}
					scopes={resolvedScopes}
				/>
			))}
		</ul>
	);
});

export default ColumnList;
